module.exports = __webpack_public_path__ + "img/map.f60727aa.svg";